export default __webpack_public_path__ + "static/media/4751.81503fdc.png";